import React from 'react';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import ContactBase from 'modules/static-pages/contact-page/pages/contact-page.base';
import StaticPageLayoutDesktop from 'layouts/static-page-layout/static-page-layout.desktop';
import { modals } from '../../../../reducers/modals';

const ContactDesktop: React.FC = () => (
    <StaticPageLayoutDesktop>
        <ContactBase />
    </StaticPageLayoutDesktop>
);

export default withFullHydrate(ContactDesktop, { root: '#root', reducers: { modals } }, 'modules/static-pages/contact-page/pages/contact-page.desktop');
